import { createSelector } from 'reselect';
import { selectors as groupSelectors } from '../../modules/groups';
import createMetadataAPISelectors from '../../utils/api-metadata-selectors';

const defaultSelectors = createMetadataAPISelectors({
  name: 'absenceRequests'
});

// If the request is reverted the end time will changed to the revert_from
// to filter the absense request that still available
const absenceRequestsById = createSelector(defaultSelectors.byId, requestById => {
  let result = {};
  for (const request of Object.values(requestById)) {
    result[request.id] = request.revert_from
      ? {
          ...request,
          end_time: request.revert_from
        }
      : request;
  }
  return result;
});
const groupsById = groupSelectors.byId;

// technically, this shows all absence requests that the user
// has access to, also the ones in different stations.
// This is similar to the problem we have with incidents.
// A similar problem is present in incidents and will need
// fix in the future.
const absenceRequestsInGroupHierarchy = createSelector(
  groupsById,
  absenceRequestsById,
  (groupsById, absenceRequestsById) => {
    const groupIds = new Set(Object.keys(groupsById).map(Number));
    return Object.values(absenceRequestsById).filter(absence => groupIds.has(absence.station_id));
  }
);

const nonRejectedAbsenceRequests = createSelector(absenceRequestsById, absenceRequestsById => {
  return Object.values(absenceRequestsById).filter(
    absence => !(absence.state === 'rejected' || absence.state === 'withdrawn')
  );
});

const nonRejectedAbsenceRequestsByMembershipId = createSelector(
  nonRejectedAbsenceRequests,
  nonRejectedAbsenceRequests => {
    const result = {};
    for (const absence of nonRejectedAbsenceRequests) {
      result[absence.membership_id] = result[absence.membership_id] || [];
      result[absence.membership_id] = [...result[absence.membership_id], absence];
    }
    return result;
  }
);

export default {
  ...defaultSelectors,
  nonRejectedAbsenceRequestsByMembershipId,
  absenceRequestsInGroupHierarchy,
  absenceRequestsById
};
